import { ApiService } from "Services/ApiService";
import { SubCategoryAdminDTO, SubCategoryAdminRequestDTO } from "Types/Admin/AdminSubCategoryType";
import { ResultsDTO } from "Types/ResultsDTO";

export const subCategoryApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllSubCategories: builder.query<SubCategoryAdminDTO[], void>({
      query: () => ({
        url: "/admin/sub-categories/",
        method: "GET",
        params: { pageSize: 1500 },
      }),
      transformResponse: (res: ResultsDTO<SubCategoryAdminDTO[]>) => res.results ?? [],
      providesTags: (result) =>
        result
          ? [
              ...result.map(({ subCategoryCode }) => ({
                type: "PrdSubCategory" as const,
                id: subCategoryCode,
              })),
              { type: "PrdSubCategory", id: "LIST" },
            ]
          : [{ type: "PrdSubCategory", id: "LIST" }],
    }),

    getSubCategoryById: builder.query<SubCategoryAdminDTO, { id: string }>({
      query: ({ id }) => ({
        url: `/admin/sub-categories/${id}`,
      }),
      transformResponse: (res: ResultsDTO<SubCategoryAdminDTO>) => res.results,
      providesTags: (result, error, { id }) => [{ type: "PrdSubCategory", id }],
    }),

    addSubCategory: builder.mutation<ResultsDTO, { data: SubCategoryAdminDTO }>({
      query: ({ data }) => ({
        url: "/admin/sub-categories/create",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "PrdSubCategory", id: "LIST" }],
    }),

    updateSubCategory: builder.mutation<ResultsDTO, { id: string; data: Partial<SubCategoryAdminRequestDTO> }>({
      query: ({ id, data }) => ({
        url: `/admin/sub-categories/update/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "PrdSubCategory", id },
      ],
    }),

    deleteSubCategory: builder.mutation<ResultsDTO, { id: string }>({
      query: ({ id }) => ({
        url: `/admin/sub-categories/delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "PrdSubCategory", id },
      ],
    }),
  }),
});

export const {
  useGetAllSubCategoriesQuery,
  useLazyGetSubCategoryByIdQuery,
  useAddSubCategoryMutation,
  useUpdateSubCategoryMutation,
  useDeleteSubCategoryMutation,
} = subCategoryApiSlice;
